// extracted by css-extract-rspack-plugin
export default {"option":"option-2hy8m","selectedIcon":"selectedIcon-QShZw","isHighlighted":"isHighlighted-1mJfc"};